export default __webpack_public_path__ + "static/media/ccc-convenience.5f7f40b1.png";